// F1 World Championship Page (1950-2020)
import React, { useEffect } from 'react';
import F1ChampionshipDashboard from '../../components/f1/F1ChampionshipDashboard';
import ErrorBanner from '../../components/ErrorBanner';

const F1ChampionshipPage = () => {
  useEffect(() => {
    document.title = 'Sydney Ferris - F1 Championship Data';
  }, []);
  return (
    <div className="min-h-[calc(100vh-5rem)] theme-bg-secondary">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <ErrorBanner 
          title="Under Construction" 
          message="This page is currently under construction. Features may not work as expected." 
          type="warning" 
        />
        {/* Dashboard */}
        <F1ChampionshipDashboard />
      </div>
    </div>
  );
};

export default F1ChampionshipPage;
